import React from 'react';
import { Card, CardContent, SxProps, Theme } from '@mui/material';

interface ChartCardWrapperProps {
  children: React.ReactNode;
  padding?: any;
  sx?: SxProps<Theme>;
}

/**
 * ChartCardWrapper - A reusable wrapper component for chart cards
 * 
 * This component provides consistent Card styling (boxShadow: 2, borderRadius: 2)
 * and CardContent padding across all chart components.
 * 
 * @param children - The content to be wrapped
 * @param padding - CardContent padding value (default: 3)
 * @param sx - Additional styles to merge with default Card styles
 */
const ChartCardWrapper: React.FC<ChartCardWrapperProps> = ({
  children,
  padding = { xs: 2, sm: 3 },
  sx = {}
}) => {
  return (
    <Card sx={{ boxShadow: 3, borderRadius: 3, ...sx }}>
      <CardContent sx={{ padding }}>
        {children}
      </CardContent>
    </Card>
  );
};

export default ChartCardWrapper;
